import { render } from "./RevuPage.vue?vue&type=template&id=2cb96bc8"
import script from "./RevuPage.vue?vue&type=script&lang=js"
export * from "./RevuPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__